import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { toast } from "react-toastify";
import SummaryApi from "../../common/SummaryApi";
import api from "../../common/apiClient";
import { FaEdit } from "react-icons/fa";
import SelectDropdown from "../../customStyles/SelectDropdown";
const EditOnboardingClient = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const client = location.state?.client;

  //   const [handleBy, setHandleBy] = useState(client?.handleBy?._id || "");

  const [clientStatus, setClientStatus] = useState(
    client?.clientStatus || "",
  );
  const [remarks, setRemarks] = useState("");
  const [clientType, setClientType] = useState(
    client?.clientType || "",
  );
  const [editModal, setEditModal] = useState({
    open: false,
    type: null,
  });

  const [users, setUsers] = useState([]);

  const [selectedHandleBy, setSelectedHandleBy] = useState(
    client?.handleBy?._id || "",
  );

  const [clientData, setClientData] = useState(client);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await api.get(SummaryApi.getAllUsers.url);

      if (response.data.success) {
        const formatted = response.data.data
          .filter((u) => u.isActive !== false)
          .map((u) => ({
            label: `${u.firstName} ${u.lastName}`,
            value: u._id,
          }));

        setUsers(formatted);
      }
    } catch (error) {
      console.error(error);
    }
  };

const updateHandleBy = async () => {
  try {
    if (!selectedHandleBy) {
    toast.error("Please select handle by user");
    return;
    }
    const response = await api({
      ...SummaryApi.updateHandleBy,
      url: SummaryApi.updateHandleBy.url(client._id),
      data: {
        handleBy: selectedHandleBy,
      },
    });

    setClientData((prev) => ({
      ...prev,
      handleBy: response.data.data.handleBy,
    }));

    setEditModal({
      open: false,
      type: null,
    });

    toast.success("Handle By updated successfully");
  } catch (error) {
    toast.error(
      error?.response?.data?.message ||
        "Failed to update handle by"
    );
  }
};

const updateStatus = async () => {
  try {

    if (!clientStatus) {
      toast.error("Please select client status");
      return;
    }

    if (!remarks.trim()) {
      toast.error("Remarks is required");
      return;
    }

    await api({
      ...SummaryApi.updateClientStatus,
      url: SummaryApi.updateClientStatus.url(client.onboardingId),
      data: {
        clientStatus,
        remarks,
      },
    });

    setClientData((prev) => ({
      ...prev,
      clientStatus,
    }));

    setEditModal({
      open: false,
      type: null,
    });

    setRemarks("");

    toast.success("Client status updated");

  } catch (error) {
    toast.error(
      error?.response?.data?.message ||
      "Failed to update status"
    );
  }
};

const updateType = async () => {
  try {

    if (!clientType) {
      toast.error("Please select client type");
      return;
    }

    if (!remarks.trim()) {
      toast.error("Remarks is required");
      return;
    }

    await api({
      ...SummaryApi.updateClientType,
      url: SummaryApi.updateClientType.url(client.onboardingId),
      data: {
        clientType,
        remarks,
      },
    });

    setClientData((prev) => ({
      ...prev,
      clientType,
    }));

    setEditModal({
      open: false,
      type: null,
    });

    setRemarks("");

    toast.success("Client type updated");

  } catch (error) {
    toast.error(
      error?.response?.data?.message ||
      "Failed to update client type"
    );
  }
};

  if (!client) {
    return <div className="p-6">Client details not found</div>;
  }

  return (
    <div className="w-full p-4">
      <div className="flex items-center mb-6">
        <button
          onClick={() => navigate(-1)}
          className="mr-3 p-2 rounded-full hover:bg-gray-200"
        >
          <FaArrowLeft />
        </button>

        <h1 className="text-2xl font-bold">Client Onboarding Management</h1>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-xl shadow p-5">
          <h2 className="text-lg font-semibold mb-4 text-red-600">Client Information</h2>

          <div className="space-y-4">
            <div>
              <label className="text-sm text-gray-500">Client ID</label>

              <p className="font-medium">{client.clientId}</p>
            </div>

            <div>
              <label className="text-sm text-gray-500">Client Name</label>

              <p className="font-medium">{client.clientName}</p>
            </div>

            <div>
              <label className="text-sm text-gray-500">Contact Person</label>

              <p className="font-medium">{client.contactName}</p>
            </div>

            <div>
              <label className="text-sm text-gray-500">Contact Number</label>

              <p className="font-medium">{client.contactPhone}</p>
            </div>

            <div>
              <label className="text-sm text-gray-500">Industry</label>

              <p className="font-medium">{client.industryType}</p>
            </div>

            <div>
              <label className="text-sm text-gray-500">Sub Industry</label>

              <p className="font-medium">{client.industrySubType}</p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow p-5">
          <h2 className="text-lg font-semibold mb-4 text-red-600">Business Details</h2>

          <div className="space-y-4">
            <div>
              <label className="text-sm text-gray-500">Product Category</label>

              <p className="font-medium">
                {client.productCategory?.join(", ")}
              </p>
            </div>

            <div>
              <label className="text-sm text-gray-500">Requirement</label>

              <p className="font-medium">{client.requirement?.join(", ")}</p>
            </div>

            <div>
              <label className="text-sm text-gray-500">Estimated Value</label>

              <p className="font-medium">₹ {client.estimatedValue}</p>
            </div>

            <div>
              <label className="text-sm text-gray-500">Expected Value</label>

              <p className="font-medium">₹ {client.expectedValue}</p>
            </div>

            <div>
              <label className="text-sm text-gray-500">Won Date</label>

              <p className="font-medium">
                {new Date(client.stageChangedAt).toLocaleDateString()}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-6 bg-white rounded-xl shadow p-5">
        <h2 className="text-lg font-semibold mb-4 text-red-600">Onboarding Details</h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="text-sm text-gray-500">Onboarding Status</label>

            <p className="font-medium">
              {client.onboardingStatus || "NOT STARTED"}
            </p>
          </div>

          <div>
            <label className="text-sm text-gray-500">Client Status</label>

            <p className="font-medium">{clientData.clientStatus || "N/A"}</p>
          </div>

          <div>
            <label className="text-sm text-gray-500">Client Type</label>

            <p className="font-medium">
              {clientData.clientType || "N/A"}
            </p>
          </div>
        </div>
      </div>

      <div className="mt-6 bg-white rounded-xl shadow-sm border border-red-100 p-5">
        <h2 className="text-lg font-semibold text-red-600 mb-4">
          Onboarding Settings
        </h2>

        <div className="space-y-4">
          <div className="flex items-center justify-between border rounded-lg p-3">
            <div>
              <p className="text-xs text-gray-500">Handle By</p>

              <p className="font-medium">
                {clientData?.handleBy
                  ? `${clientData.handleBy.firstName} ${clientData.handleBy.lastName}`
                  : "Not Assigned"}
              </p>
            </div>

            <button
              onClick={() =>
                setEditModal({
                  open: true,
                  type: "HANDLE_BY",
                })
              }
              className="text-red-600"
            >
              <FaEdit />
            </button>
          </div>

          <div className="flex items-center justify-between border rounded-lg p-3">
            <div>
              <p className="text-xs text-gray-500">Client Status</p>

              <p className="font-medium">{clientStatus}</p>
            </div>

            <button
              onClick={() =>
                setEditModal({
                  open: true,
                  type: "CLIENT_STATUS",
                })
              }
              className="text-red-600"
            >
              <FaEdit />
            </button>
          </div>

          <div className="flex items-center justify-between border rounded-lg p-3">
            <div>
              <p className="text-xs text-gray-500">Client Type</p>

              <p className="font-medium">{clientType}</p>
            </div>

            <button
              onClick={() =>
                setEditModal({
                  open: true,
                  type: "CLIENT_TYPE",
                })
              }
              className="text-red-600"
            >
              <FaEdit />
            </button>
          </div>
        </div>
      </div>

      {editModal.open && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-[70]">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-5">
            <div className="flex items-center justify-between mb-5">
              <h2 className="text-xl font-semibold text-red-600">
                {editModal.type === "HANDLE_BY" && "Update Handle By"}
                {editModal.type === "CLIENT_STATUS" && "Update Client Status"}
                {editModal.type === "CLIENT_TYPE" && "Update Client Type"}
              </h2>

              <button
                onClick={() =>
                  setEditModal({
                    open: false,
                    type: null,
                  })
                }
                className="text-gray-500 hover:text-red-600"
              >
                ✕
              </button>
            </div>

            {/* HANDLE BY */}
            {editModal.type === "HANDLE_BY" && (
              <>
                <SelectDropdown
                  options={users}
                  value={selectedHandleBy}
                  onChange={(value) => setSelectedHandleBy(value)}
                  placeholder="Select User"
                  valueKey="value"
                  labelKey="label"
                  searchable
                  zIndex={71}
                />

                <div className="flex justify-end gap-3 mt-5">
                  <button
                    onClick={() =>
                      setEditModal({
                        open: false,
                        type: null,
                      })
                    }
                    className="px-4 py-2 border rounded-lg"
                  >
                    Cancel
                  </button>

                  <button
                    onClick={updateHandleBy}
                    className="px-5 py-2 bg-red-600 text-white rounded-lg"
                  >
                    Update
                  </button>
                </div>
              </>
            )}

            {/* CLIENT STATUS */}
            {editModal.type === "CLIENT_STATUS" && (
              <>
                <div className="space-y-3">
                  {["ACTIVE", "INACTIVE", "ONETIME"].map((status) => (
                    <label
                      key={status}
                      className="flex items-center gap-3 border rounded-lg p-3 cursor-pointer"
                    >
                      <input
                        type="radio"
                        value={status}
                        checked={clientStatus === status}
                        onChange={(e) => setClientStatus(e.target.value)}
                      />
                      {status}
                    </label>
                  ))}
                </div>

                <div className="mt-4">
                  <label className="block text-sm font-medium mb-2">
                    Remarks *
                  </label>

                  <textarea
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    rows={4}
                    className="w-full border rounded-lg p-3"
                    placeholder="Enter remarks"
                  />
                </div>

                <div className="flex justify-end gap-3 mt-5">
                  <button
                    onClick={() =>
                      setEditModal({
                        open: false,
                        type: null,
                      })
                    }
                    className="px-4 py-2 border rounded-lg"
                  >
                    Cancel
                  </button>

                  <button
                    onClick={updateStatus}
                    className="px-5 py-2 bg-red-600 text-white rounded-lg"
                  >
                    Update
                  </button>
                </div>
              </>
            )}

            {/* CLIENT TYPE */}
            {editModal.type === "CLIENT_TYPE" && (
              <>
                <div className="space-y-3">
                  {["RECURRING", "NON_RECURRING"].map((type) => (
                    <label
                      key={type}
                      className="flex items-center gap-3 border rounded-lg p-3 cursor-pointer"
                    >
                      <input
                        type="radio"
                        value={type}
                        checked={clientType === type}
                        onChange={(e) => setClientType(e.target.value)}
                      />
                      {type}
                    </label>
                  ))}
                </div>

                <div className="mt-4">
                  <label className="block text-sm font-medium mb-2">
                    Remarks *
                  </label>

                  <textarea
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    rows={4}
                    className="w-full border rounded-lg p-3"
                    placeholder="Enter remarks"
                  />
                </div>

                <div className="flex justify-end gap-3 mt-5">
                  <button
                    onClick={() =>
                      setEditModal({
                        open: false,
                        type: null,
                      })
                    }
                    className="px-4 py-2 border rounded-lg"
                  >
                    Cancel
                  </button>

                  <button
                    onClick={updateType}
                    className="px-5 py-2 bg-red-600 text-white rounded-lg"
                  >
                    Update
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default EditOnboardingClient;
